<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    {
                        text: 'Growth Tasks',
                        disable: false,
                        href: '/#/growthtasks'
                    },
                    { text: 'All actions', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
        </v-row>

        <!-- GrowthTask Dialog -->
        <v-dialog v-model="growthTaskDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeGrowthTaskDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title
                        >Growth Task ID{{
                            selectedGrowthTaskRawId
                        }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToGrowthTaskDetail(selectedGrowthTaskNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <GrowthTaskDetailComponent
                        v-if="selectedGrowthTaskNodeId"
                        :growthTaskNodeId="selectedGrowthTaskNodeId"
                        v-on:growthTask-items-updated="updateTableOptions"
                        v-on:item-deleted="onGrowthTaskDeleted"
                    ></GrowthTaskDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Growth task Edit dialog -->
        <GrowthTaskEditDialog
            :dialog.sync="growthTaskEditDialog"
            v-on:item-created="updateTableOptions"
        ></GrowthTaskEditDialog>

        <v-row>
            <v-col>
                <v-hover>
                    <v-card>
                        <v-card-title class="pb-0">
                            <v-col sm="12" md="2">
                                <v-icon color="primary" class="ma-1"
                                    >date_range</v-icon
                                >
                                <span class="ma-2">All actions</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="3" sm="4" md="3">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="dates"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                    :close-on-click="false"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            ref="texto"
                                            v-model="formatedDateInputField"
                                            label="Start Date Range"
                                            clearable
                                            v-bind="attrs"
                                            v-on="on"
                                            :disabled="
                                                $apollo.queries.growthTaskPhases
                                                    .loading
                                            "
                                            dense
                                            @click:clear="resetDates()"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dates"
                                        no-title
                                        show-week
                                        :first-day-of-week="1"
                                        locale-first-day-of-year="4"
                                        scrollable
                                        range
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.menu.save(dates)"
                                        >
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="2" md="1">
                                <v-autocomplete
                                    v-model="selectedPhase"
                                    :items="planFilterPhaseList"
                                    :disabled="
                                        $apollo.queries.growthTaskPhases.loading
                                    "
                                    item-value="phaseNo"
                                    item-text="phase"
                                    label="Phase"
                                    dense
                                    clearable
                                >
                                </v-autocomplete>
                            </v-col>
                            <!--<v-col cols="2" md="2">
                                    <v-autocomplete label="Department" dense></v-autocomplete>
                                </v-col>-->

                            <v-col cols="2" md="2">
                                <v-autocomplete
                                    clearable
                                    label="Pot Size(cm)"
                                    :items="tenantPotSizes.edges"
                                    item-text="node.potSizeCm"
                                    item-value="node.id"
                                    dense
                                    v-model="selectedPotSize"
                                    @click:clear="resetPotSize()"
                                    :disabled="
                                        $apollo.queries.growthTaskPhases.loading
                                    "
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" sm="3" md="3">
                                <v-text-field
                                    label="Search"
                                    clearable
                                    append-outer-icon="refresh"
                                    dense
                                    v-model="search"
                                    @keydown.enter="updateTableOptions()"
                                    @click:clear="resetSearchBar()"
                                    @click:append-outer="updateTableOptions()"
                                    :disabled="
                                        $apollo.queries.growthTaskPhases.loading
                                    "
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <vue-excel-xlsx
                                    :fetch="userRequestExcel"
                                    :columns="excelColumns"
                                    :file-name="'AllActionsExport'"
                                    :file-type="'xlsx'"
                                    :sheet-name="'sheetname'"
                                >
                                    <v-btn
                                        small
                                        outlined
                                        color="primary"
                                        rounded
                                        class="mx-0 mb-3"
                                        dense
                                        :disabled="
                                            growthTaskPhases &&
                                            growthTaskPhases.edges &&
                                            growthTaskPhases.edges.length > 0
                                                ? false
                                                : true
                                        "
                                        :loading="isExportingExcel"
                                    >
                                        Download
                                    </v-btn>
                                </vue-excel-xlsx>
                            </v-col>
                        </v-card-title>
                        <v-container fluid>
                            <v-data-table
                                :headers="headers"
                                :items="growthTaskPhases.edges"
                                :loading="
                                    $apollo.queries.growthTaskPhases.loading
                                "
                                :options.sync="opcoes"
                                :items-per-page="defaultItemsPerPage"
                                :server-items-length="
                                    growthTaskPhases.totalCount
                                "
                                :footer-props="{
                                    'items-per-page-options': [
                                        5,
                                        10,
                                        25,
                                        50,
                                        75,
                                        100
                                    ],
                                    'disable-pagination':
                                        $apollo.queries.growthTaskPhases.loading
                                }"
                            >
                                <template
                                    v-slot:item.node.greenhouseDepartmentSection="{
                                        item
                                    }"
                                >
                                    <span v-if="item.node">
                                        {{
                                            item.node
                                                .greenhouseDepartmentSection
                                                .greenhouseDepartment.greenhouse
                                                .name
                                        }}
                                        -
                                        {{
                                            item.node
                                                .greenhouseDepartmentSection
                                                .greenhouseDepartment.name
                                        }}
                                        -
                                        {{
                                            item.node
                                                .greenhouseDepartmentSection
                                                .name
                                        }}</span
                                    >
                                </template>
                                <template v-slot:item.node.createdAt="{ item }">
                                    <span>{{
                                        item.node.createdAt
                                            | moment("YYYY-MM-DD")
                                    }}</span>
                                </template>
                                <template
                                    v-slot:item.node.startDate="{
                                        item
                                    }"
                                >
                                    <span
                                        >{{
                                            item.node.startDate
                                                | moment("YYYY-MM-DD ([W]WW)")
                                        }}
                                    </span>
                                </template>
                                <template v-slot:item.node.phaseNo="{ item }">
                                    <v-chip
                                        class="my-1"
                                        small
                                        color="warning"
                                        v-if="item.node.isSalesPhase"
                                        >Sales</v-chip
                                    >
                                    <v-chip
                                        class="my-1"
                                        small
                                        dark
                                        color="success"
                                        v-else-if="item.node.phaseNo == 1"
                                        >P{{ item.node.phaseNo }}</v-chip
                                    >
                                    <v-chip
                                        class="my-1"
                                        small
                                        outlined
                                        color="success"
                                        v-else
                                        >P{{ item.node.phaseNo }}</v-chip
                                    >
                                </template>
                                <template
                                    v-slot:item.node.growthTask.potSize.potSizeCm="{
                                        item
                                    }"
                                >
                                    <span>
                                        {{
                                            item.node.growthTask.potSize
                                                .potSizeCm
                                        }}
                                        cm
                                    </span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn
                                        icon
                                        color="primary"
                                        @click="openGrowthTaskDialog(item.node)"
                                    >
                                        <v-icon>remove_red_eye</v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        color="primary"
                                        @click="
                                            goToGrowthTaskDetail(
                                                item.node.growthTask.id
                                            )
                                        "
                                    >
                                        <v-icon>launch</v-icon>
                                    </v-btn>
                                    <!-- <v-icon small @click="onDeletingTask(item.node)">delete</v-icon> -->
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import GrowthTaskEditDialog from "@/components/growth/GrowthTaskEditDialog.vue";
import GrowthTaskDetailComponent from "@/components/growth/GrowthTaskDetailComponent.vue";
import moment from "moment";

export default {
    name: "growthTaskPhases",
    components: {
        GrowthTaskEditDialog,
        GrowthTaskDetailComponent
    },

    apollo: {
        tenantPotSizes: {
            query: gql`
                query tenantPotSizes {
                    tenantPotSizes(orderBy: "potSizeCm") {
                        edges {
                            node {
                                id
                                potSizeCm
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => {
                return data.tenantPotSizes;
            },
            skip: false
        },
        growthTaskPhases: {
            query: gql`
                query TenantGrowthTaskPhases(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $search: String
                    $startDateGte: Date
                    $startDateLte: Date
                    $phaseNo: Int
                    $growthTaskPotSizeId: ID
                    $growthTaskTotalInventoryGt: Int
                    $greenhouseDepartmentSectionGreenhouseDepartmentId: ID
                    $isSalesPhase: Boolean
                ) {
                    tenantGrowthTaskPhases(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        orderBy: $orderBy
                        search: $search
                        startDate_Gte: $startDateGte
                        startDate_Lte: $startDateLte
                        phaseNo: $phaseNo
                        growthTask_PotSizeId: $growthTaskPotSizeId
                        growthTask_TotalInventory_Gt: $growthTaskTotalInventoryGt
                        greenhouseDepartmentSection_GreenhouseDepartment_Id: $greenhouseDepartmentSectionGreenhouseDepartmentId
                        isSalesPhase: $isSalesPhase
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                phaseNo
                                isSalesPhase
                                startDate
                                endDate
                                createdAt
                                confirmedDate
                                greenhouseDepartmentSection {
                                    id
                                    name
                                    greenhouseDepartment {
                                        id
                                        name
                                        greenhouse {
                                            id
                                            name
                                        }
                                    }
                                }
                                growthTask {
                                    id
                                    plant {
                                        id
                                        name
                                        plantSpecies {
                                            id
                                            name
                                        }
                                    }
                                    rawId
                                    note
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    color {
                                        id
                                        color
                                    }
                                    environment {
                                        id
                                        environment
                                    }
                                    tag {
                                        id
                                        tag
                                    }
                                    totalInventory
                                    createdAt
                                }
                            }
                        }
                    }
                }
            `,
            // Parameters
            variables() {
                return {
                    first: this.defaultItemsPerPage,
                    search: this.search,
                    phaseNo: this.selectedPhase > 0 ? this.selectedPhase : null,
                    startDateGte: this.dates.length == 2 ? this.dates[0] : null,
                    startDateLte: this.dates.length == 2 ? this.dates[1] : null,
                    greenhouseDepartmentSectionGreenhouseDepartmentId: null,
                    growthTaskPotSizeId: this.selectedPotSize,
                    growthTaskTotalInventoryGt: 0,
                    isSalesPhase: this.selectedPhase == 0 ? true : false
                };
            },
            fetchPolicy: "cache-and-network",
            update: data => {
                return data.tenantGrowthTaskPhases;
            },
            skip: false
        }
    },
    data() {
        return {
            deleteTaskDialog: false,
            growthTaskEditDialog: false,
            growthTaskDialog: false,
            isLoadingGrowthTasks: false,
            isExportingExcel: false,
            menu: false,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            opcoes: {},
            dates: [],
            page: 1,
            growthTaskPhases: {},
            growthTaskWeekStart: [],
            shouldResetDataTablePage: false,
            tenantGrowthTasks: {},
            tenantPotSizes: {},
            selectedPotSize: null,
            selectedGrowthTaskNodeId: null,
            selectedGrowthTaskRawId: null,
            selectedPlanListPotSizeId: null,
            selectedPhase: null,

            search: "",
            toggleGrowthTaskScope: 0,

            deletingGrowthTask: null,
            filteredGrowthTasks: [],
            greenhouseDepartments: [],
            selectedDepartments: [],
            //Only test data
            headers: [
                //{text:"", value:"warning", width: "40px", sortable: false},
                { text: "Start Date", value: "node.startDate", sortable: true },
                //{text:"ID", value:"node.growthTask.rawId", sortable: true},
                {
                    text: "Department",
                    value: "node.greenhouseDepartmentSection",
                    sortable: true
                },
                {
                    text: "Plant Species",
                    value: "node.growthTask.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "node.growthTask.plant.name",
                    sortable: true
                },
                {
                    text: "Next Phase",
                    value: "node.phaseNo"
                },
                {
                    text: "Note",
                    value: "node.growthTask.note",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.growthTask.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    value: "node.growthTask.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.growthTask.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.growthTask.tag.tag",
                    sortable: true
                },
                {
                    text: "Inventory",
                    value: "node.growthTask.totalInventory",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    sortable: false,
                    width: "120px",
                    align: "center"
                }
            ],
            excelColumns: [
                {
                    label: "Start Date",
                    field: "node.startDate"
                },
                {
                    label: "Department",
                    // field: "node.greenhouseDepartmentSection.greenhouseDepartment.name",
                    field: {
                        callback: value => {
                            return (
                                value.node.greenhouseDepartmentSection
                                    .greenhouseDepartment.greenhouse.name +
                                " - " +
                                value.node.greenhouseDepartmentSection
                                    .greenhouseDepartment.name +
                                " - " +
                                value.node.greenhouseDepartmentSection.name
                            );
                        }
                    }
                },
                {
                    label: "Plant Species",
                    field: "node.growthTask.plant.plantSpecies.name"
                },
                {
                    label: "Plant",
                    field: "node.growthTask.plant.name"
                },
                {
                    label: "Next Phase",
                    field: {
                        callback: value => {
                            if (value.node.isSalesPhase) return "Sales";
                            else return "P" + value.node.phaseNo;
                        }
                    }
                },
                {
                    label: "Note",
                    field: "node.growthTask.note"
                },
                {
                    label: "Pot Size",
                    field: "node.growthTask.potSize.potSizeCm"
                },
                {
                    label: "Color",
                    field: {
                        callback: value => {
                            if (value.node.growthTask.color != null)
                                return value.node.growthTask.color.color;
                        }
                    }
                },
                {
                    label: "Environemnt",
                    field: {
                        callback: value => {
                            if (value.node.growthTask.color != null)
                                return value.node.growthTask.environment
                                    .environment;
                        }
                    }
                },
                {
                    label: "Tag",
                    field: {
                        callback: value => {
                            if (value.node.growthTask.tag != null)
                                return value.node.growthTask.tag.tag;
                        }
                    }
                },
                {
                    label: "Inventory",
                    field: "node.growthTask.totalInventory"
                }
            ],
            planFilterPhaseList: [
                { phase: "P1", phaseNo: 1 },
                { phase: "P2", phaseNo: 2 },
                { phase: "P3", phaseNo: 3 },
                { phase: "P4", phaseNo: 4 },
                { phase: "P5", phaseNo: 5 },
                { phase: "Sales", phaseNo: 0 }
            ],

            editedIndex: -1
        };
    },
    computed: {
        today() {
            var _now = new Date();

            return moment(_now).format("YYYY-MM-DD");
        },
        formatedDateInputField: {
            get() {
                return this.dates && this.dates.length > 1
                    ? this.dates.join(" to ").replace(/-/g, "/")
                    : "";
            },
            set(value) {
                this.dates = value === null ? [] : value;
            }
        }
    },
    watch: {
        opcoes: {
            handler() {
                this.updateTableOptions();
            }
        },
        dates() {
            let savedDate;
            if (!this.dates) return;
            if (this.dates[0] > this.dates[1]) {
                savedDate = this.dates[0];
                this.dates[0] = this.dates[1];
                this.dates[1] = savedDate;
            }
            if (this.dates.length == 2 || this.dates == []) {
                this.updateTableOptions();
            }
        },
        selectedPotSize() {
            this.updateTableOptions();
        },
        selectedPhase() {
            this.updateTableOptions();
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        // get tab of last visit from local
        if (localStorage.getItem("toggleGrowthTaskScope") != null) {
            this.toggleGrowthTaskScope = parseInt(
                localStorage.getItem("toggleGrowthTaskScope")
            );
        } else {
            this.toggleGrowthTaskScope = 0;
        }
    },
    methods: {
        async userRequestExcel() {
            this.isExportingExcel = true;

            const { sortBy, sortDesc } = this.opcoes;

            var _first = 1000;
            var _before = null;
            var _after = null;
            var _last = null;
            var _orderBy = null;

            switch (sortBy[0]) {
                case "node.phaseNo":
                    _orderBy = "phaseNo";
                    break;
                case "node.greenhouseDepartmentSection.greenhouseDepartment.name":
                    _orderBy = "greenhouseDepartmentSectionName";
                    break;
                case "node.startDate":
                    _orderBy = "startDate";
                    break;
                case "node.growthTask.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.growthTask.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.growthTask.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.growthTask.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.growthTask.color.color":
                    _orderBy = "color";
                    break;
                case "node.growthTask.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.growthTask.note":
                    _orderBy = "note";
                    break;
                case "node.growthTask.totalInventory":
                    _orderBy = "totalInventory";
                    break;
                case "node.salesStartDate":
                    _orderBy = "salesStartDate";
                    break;
                case "node.createdAt":
                    _orderBy = "createdAt";
                    break;
                default:
                    _orderBy = "startDate";
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            const result = this.$apollo
                .query({
                    // Query
                    query: gql`
                        query TenantGrowthTaskPhases(
                            $first: Int
                            $last: Int
                            $before: String
                            $after: String
                            $orderBy: String
                            $search: String
                            $startDateGte: Date
                            $startDateLte: Date
                            $phaseNo: Int
                            $growthTaskPotSizeId: ID
                            $growthTaskTotalInventoryGt: Int
                            $greenhouseDepartmentSectionGreenhouseDepartmentId: ID
                            $isSalesPhase: Boolean
                        ) {
                            tenantGrowthTaskPhases(
                                first: $first
                                last: $last
                                before: $before
                                after: $after
                                orderBy: $orderBy
                                search: $search
                                startDate_Gte: $startDateGte
                                startDate_Lte: $startDateLte
                                phaseNo: $phaseNo
                                growthTask_PotSizeId: $growthTaskPotSizeId
                                growthTask_TotalInventory_Gt: $growthTaskTotalInventoryGt
                                greenhouseDepartmentSection_GreenhouseDepartment_Id: $greenhouseDepartmentSectionGreenhouseDepartmentId
                                isSalesPhase: $isSalesPhase
                            ) {
                                edgeCount
                                totalCount
                                pageInfo {
                                    startCursor
                                    endCursor
                                    hasPreviousPage
                                    hasNextPage
                                }
                                edges {
                                    node {
                                        phaseNo
                                        isSalesPhase
                                        startDate
                                        endDate
                                        createdAt
                                        confirmedDate
                                        greenhouseDepartmentSection {
                                            id
                                            name
                                            greenhouseDepartment {
                                                id
                                                name
                                                greenhouse {
                                                    id
                                                    name
                                                }
                                            }
                                        }
                                        growthTask {
                                            id
                                            plant {
                                                id
                                                name
                                                plantSpecies {
                                                    id
                                                    name
                                                }
                                            }
                                            rawId
                                            note
                                            potSize {
                                                id
                                                potSizeCm
                                            }
                                            color {
                                                id
                                                color
                                            }
                                            environment {
                                                id
                                                environment
                                            }
                                            tag {
                                                id
                                                tag
                                            }
                                            totalInventory
                                            createdAt
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        first: _first,
                        last: _last,
                        before: _before,
                        after: _after,
                        orderBy: _orderBy,
                        search: this.search,
                        phaseNo:
                            this.selectedPhase > 0 ? this.selectedPhase : null,
                        startDateGte:
                            this.dates.length == 2 ? this.dates[0] : null,
                        startDateLte:
                            this.dates.length == 2 ? this.dates[1] : null,
                        greenhouseDepartmentSectionGreenhouseDepartmentId: null,
                        growthTaskPotSizeId: this.selectedPotSize,
                        growthTaskTotalInventoryGt: 0,
                        isSalesPhase: this.selectedPhase == 0 ? true : false
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    return response.data.tenantGrowthTaskPhases.edges;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isExportingExcel = false;
                });
            return result;
        },
        updateTableOptions() {
            const { sortBy, page, itemsPerPage, sortDesc } = this.opcoes;

            var _first = itemsPerPage;
            var _before = null;
            var _after = null;
            var _last = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.growthTaskPhases.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _before = null;
                _after = this.growthTaskPhases.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.phaseNo":
                    _orderBy = "phaseNo";
                    break;
                case "node.greenhouseDepartmentSection.greenhouseDepartment.name":
                    _orderBy = "greenhouseDepartmentSectionName";
                    break;
                case "node.startDate":
                    _orderBy = "startDate";
                    break;
                case "node.growthTask.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.growthTask.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.growthTask.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.growthTask.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.growthTask.color.color":
                    _orderBy = "color";
                    break;
                case "node.growthTask.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.growthTask.note":
                    _orderBy = "note";
                    break;
                case "node.growthTask.totalInventory":
                    _orderBy = "totalInventory";
                    break;
                case "node.salesStartDate":
                    _orderBy = "salesStartDate";
                    break;
                case "node.createdAt":
                    _orderBy = "createdAt";
                    break;
                default:
                    _orderBy = "startDate";
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.growthTaskPhases.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.search,
                phaseNo: this.selectedPhase > 0 ? this.selectedPhase : null,
                startDateGte: this.dates.length == 2 ? this.dates[0] : null,
                startDateLte: this.dates.length == 2 ? this.dates[1] : null,
                greenhouseDepartmentSectionGreenhouseDepartmentId: null,
                growthTaskPotSizeId: this.selectedPotSize,
                growthTaskTotalInventoryGt: 0,
                isSalesPhase: this.selectedPhase == 0 ? true : false
            });

            // set skip false to execute the query
            this.$apollo.queries.growthTaskPhases.skip = false;
            this.$apollo.queries.growthTaskPhases.refresh();

            // update this.page
            this.page = page;
        },
        resetPotSize() {
            this.selectedPotSize = null;
        },
        resetSearchBar() {
            this.search = "";
            this.updateTableOptions();
        },
        resetDates() {
            this.dates = [];
            this.updateTableOptions();
        },

        calculateDaysBetweenDays(day1, day2) {
            return moment(day1).diff(moment(day2), "day");
        },
        openGrowthTaskDialog(node) {
            this.selectedGrowthTaskNodeId = node.growthTask.id;
            this.selectedGrowthTaskRawId = node.growthTask.rawId;
            this.growthTaskDialog = true;
        },
        closeGrowthTaskDialog() {
            this.growthTaskDialog = false;
            this.selectedGrowthTaskNodeId = null;
            this.selectedGrowthTaskRawId = null;
            this.$apollo.queries.growthTaskPhases.refresh();
        },
        onGrowthTaskDeleted() {
            this.closeGrowthTaskDialog();
        },
        goToGrowthTaskDetail(growthTaskNodeId) {
            let routeData = this.$router.resolve({
                name: "growthtask-detail",
                params: { id: growthTaskNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        goToGrowthTaskSettings() {
            this.$router.push({
                name: "growth-task-settings"
            });
        }
    }
};
</script>

